import React from 'react';
import PropTypes from 'prop-types';
import usePromise from 'src/hooks/usePromise';
import LoadingButton from '@mui/lab/LoadingButton';

const CustomButton = ({ loading, onClick, style, className, ...rest }) => {
  const [isLoading, handler] = usePromise(onClick, loading);
  return (
    <LoadingButton
      style={{ ...style }}
      className={className}
      loading={isLoading}
      disabled={isLoading}
      onClick={handler}
      variant="contained"
      color="inherit"
      {...rest}
    />
  );
};

CustomButton.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CustomButton;
